import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const ROADCARGOTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.RoadCargoType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const ROADCARGOTYPE_CONFIG = {
  entityName: 'RoadCargoType',
  localizationKey: 'Controlling::Entity.RoadCargoType',
  fields: ROADCARGOTYPE_FIELDS,
  permission: 'ControllingActivities.RoadCargoTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
